export default "__VITE_ASSET__5a0b6f86__"